import type { Size } from "@suse-o11y/size";
import { createContext } from "react";

const StageSizeContext = createContext<null | Size>(null);

export const StageContextProvider = StageSizeContext.Provider;
